<template>
  <div class="bannerImg">
    <div class="bbg"></div>

    <div class="banner_main">
      <div :class="userInfo && userInfo.id ? 'banner_main_left banner_main_lefts' : 'banner_main_left '">
        <el-carousel height="360px" class="swImg" arrow="never">
          <el-carousel-item v-for="(item, index) in imgList" :key="index" class="pointer">
            <img :src="item.img" @click="nav(item)" />
          </el-carousel-item>
        </el-carousel>
      </div>
      <div v-if="!userInfo" class="banner_main_right">
        <div class="login">
          <div class="line"></div>
          <p>欢迎来到</p>
          <p>{{ domain.name }}</p>
          <div class="l_img">
            <img src="~@/assets/img/TechnicalCollege/99.png" alt="" />
          </div>
          <div @click="gogo()" class="contentTopBtn">去登录</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from 'vue'
import "@/assets/css/common.css";
import swipers from "@/components/swipers.vue";
import { getSurfaceList, } from "@/api/home";
import { getInfo } from "@/api/cookies";
import { getDomain } from "@/api/cookies";
export default {
  components: { swipers },
  data() {
    return {
      imgList: [],
      domain: null,
      imgUrl: "",
      userSource: "PC端",
      userInfo: null
    };
  },
  async created() {
    this.domain = getDomain();
    this.userInfo = await getInfo();
    getSurfaceList(1, undefined, this.domain.entrantsType).then((res) => {
      if (res.code == 0) {
        this.imgList = JSON.parse(JSON.stringify(res.msg));
      }
    });
  },
  methods: {
    gogo() {
      Vue.prototype.goLoginView(true)
    },
    nav(item) {
      window.open(item.skipImg, "_blank");
    },
    oneMouseleave() {
      this.mainBoxShow = false;
    },

    toNext(url) {
      const routeUrl = this.$router.resolve({
        path: url,
      });
      window.open(routeUrl.href, "_blank");
    },
  },
};
</script>
<style lang="less" scoped>
.bannerImg {
  width: 100%; 
  position: relative;
  padding-top: 30px;

  .bgimg {
    position: absolute;
    width: 100%;
    height: 100%;

    img {
      width: 100%;
      height: 100%;

      transition: opacity 0.5s;

      // &:hover {
      //   opacity: 0.5;
      //   /* 鼠标悬停时改变透明度 */
      // }
    }
  }
}

.bbg {
  width: 100%;
  height: 342px;
  position: absolute;
  top: 0;
  background: url('https://staticfile.xlcwx.com/m-images/yth/lzimg/careerpc/x5.png');
  background-size: 100% 100%;
}

.banner_main {
  position: relative;
  display: flex;
  width: 1400px;
  margin: 0 auto;
  justify-content: space-between;
  // margin-top: 20px;

  .banner_main_left {
    width: 1062px;
    height: 360px;
    position: relative;
    border-radius: 10px;
    overflow: hidden;

    .jg {
      position: absolute;
      bottom: 0;
      width: 100%;
      height: 80px;
      background: #ffffff;
      border-radius: 0px 0px 10px 10px;
      z-index: 999;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 52px;

      .jg_item {
        display: flex;
        align-items: center;
        cursor: pointer;

        .jg_item_left {
          width: 40px;

          img {
            width: 40px;
          }
        }

        .jg_item_right {
          margin-left: 8px;

          >div:nth-child(1) {
            font-family: Source Han Sans CN, Source Han Sans CN;
            font-weight: 400;
            font-size: 16px;
            color: #333333;
          }

          >div:nth-child(2) {
            font-family: Source Han Sans CN, Source Han Sans CN;
            font-weight: 400;
            font-size: 14px;
            color: #999999;
            // margin-top: 5px;
          }
        }
      }
    }
  }

  .banner_main_lefts {
    width: 1400px;
  }

  .banner_main_right {
    width: 320px;
    height: 360px;
    background: rgba(255, 255, 255, 0.4);
    border-radius: 10px;
    padding: 20px;
    position: relative;
border: 1px solid rgba(255,255,255,0.35);
    .login {
      // width: 170px;
      position: relative;

      .line {
        position: absolute;
        top: 47px;
        left: 0;
        width: 166px;
        height: 10px;
        background: linear-gradient(101deg, #1D7DF5 0%, rgba(29, 125, 245, 0) 100%);
        border-radius: 9px 9px 9px 9px;
      }

      p {
        position: relative;

        font-family: PingFang SC, PingFang SC;
        font-weight: bold;
        font-size: 20px;
        color: #FFFFFF;
      }

      .contentTopBtn {
        width: 156px;
        height: 50px;
        background: #1D7DF5;
        border-radius: 25px 25px 25px 25px;
        margin: 0 auto;
        margin-top: 30px;
        display: flex;
        justify-content: center;
        align-items: center;

        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        font-size: 18px;
        color: #FFFFFF;
        cursor: pointer;
      }

      .l_img {
        margin-top: 50px;

        img {
          display: block;
          margin: 0 auto;
          width: 84px;
        }
      }

      .l_til {
        font-family: Source Han Sans CN, Source Han Sans CN;
        font-weight: 400;
        font-size: 16px;
        color: #333333;
        text-align: center;
        margin-top: 15px;

        span {
          color: #1c81f5;
        }
      }
    }
  }
}

/* 轮播图 */
/deep/.swImg {
  width: 100%;
  height: 360px;
  border-radius: 0px 0px 0px 0px;
  opacity: 1;

  .el-carousel__item {
    display: flex;
    justify-content: center;
    width: 100%;
    height: 100%;
  }

  .el-carousel__arrow--left {
    left: calc(50% - 610px + 240px + 40px);
  }

  .el-carousel__arrow--right {
    right: 350px;
  }

  .el-carousel__arrow {
    width: 60px;
    height: 60px;
    background: rgba(0, 0, 0, 0.4);

    i {
      font-size: 30px;
      color: rgba(255, 255, 255, 0.8);
    }
  }

  img {
    /* max-width: 100%; */
    height: 360px;
    margin: auto;
  }
}



.el-input {
  width: 230px;
  height: 44px;
  background: #f8f8f8 !important;
  border-radius: 23px 23px 23px 23px;
}

::v-deep .el-input__inner {
  background: #f8f8f8 !important;
  border-radius: 23px 23px 23px 23px;
}

::v-deep .el-form-item__content {
  background: #f8f8f8 !important;
  border-radius: 23px 23px 23px 23px;
}

//隐藏滚动条
::-webkit-scrollbar {
  display: none !important;
  scrollbar-width: none !important;
  -ms-overflow-style: none;
}
</style>
